import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from '@Admin/admin.component';
import { ConfComponent } from '@Conf/conf.component';
import { MgmtComponent } from './Views/Mgmt/mgmt.component';
import { WorkComponent } from '@Work/work.component';
import { LoginContainerComponent } from '@Mktg/Login/login-container.component';
import { RegisterComponent } from '@Mktg/Register/register.component';
import { SelectAreaComponent } from '@Mktg/select-area/select-area.component';
import { requireTenantSelection, canActivateAltLogin } from '@Core/guards/auth.guard';
import { AuthTenant } from '@Core/enums/auth-tenant.enum';

const routes: Routes = [
    {
        // Default to the Mktg (Login) view
        path: '',
        component: LoginContainerComponent,
        data: { tenant: AuthTenant.Primary }
    },
    {
        path: 'Login',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'altlogin',
        component: LoginContainerComponent,
        canActivate: [canActivateAltLogin],
        data: { tenant: AuthTenant.Secondary }
    },
    {
        path: 'Register',
        component: RegisterComponent
    },
    {
        path: 'SelectArea',
        component: SelectAreaComponent,
        canActivate: [requireTenantSelection]
    },
    {
        path: 'Work',
        component: WorkComponent,
        loadChildren: () => import('./Views/Work/work.module').then(m => m.WorkModule)
    },
    {
        path: 'Conf',
        component: ConfComponent,
        loadChildren: () => import('./Views/Conf/conf.module').then(m => m.ConfModule)
    },
    {
        path: 'Admin',
        component: AdminComponent,
        loadChildren: () => import('./Views/Admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: 'Mgmt',
        component: MgmtComponent,
        loadChildren: () => import('./Views/Mgmt/mgmt.module').then(m => m.MgmtModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
